module.exports = __webpack_public_path__ + "public/img/product_shot_laptop.80b448a.png";